import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';

import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

const styles = {
  icon: {
    left: 8,
    marginLeft: 0,
    marginRight: 10,
  },
  innerDiv: { padding: '10px 0 10px 10px' },
};
const PageMenuItem = ({
  leftIcon,
  primaryText,
  primaryTextColor,
  ...props
}) => (
  <MenuItem {...props} style={styles.innerDiv}>
    <ListItemIcon>
      {useMemo(
        () => (leftIcon
            ? React.cloneElement(leftIcon, {
                style: styles.icon,
              })
            : null),
        [leftIcon],
      )}
      <Typography color={primaryTextColor} variant='inherit'>
        {primaryText}
      </Typography>
    </ListItemIcon>
  </MenuItem>
);

PageMenuItem.propTypes = {
  leftIcon: PropTypes.node,
  primaryText: PropTypes.string,
  primaryTextColor: PropTypes.string,
};

export default PageMenuItem;
